
import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';
import { LanguageSettingsService } from '../../services/language-settings.service';
import { SETTINGS_URL } from '../../../../services/common-urls';

// Action Object for LanguageSettings. Import the types from language/types.js and Invoke Actions from the Vuex Host Components.

export const languageSettingsActions = {
  async [types.LanguageSettingsData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const languageSettingsData = await LanguageSettingsService.findLanguageSettingsData(payload);

    console.log(languageSettingsData);
    commit(types.LanguageSettingsData.SET.ALL, languageSettingsData);
  },

  async [types.I18NEntry.INSERT.SINGLE]({getters, dispatch}, payload) {
    const i18n = payload;

    const insertedI18n = await LanguageSettingsService.insertI18NEntry(payload);
  },
  async [types.I18NEntry.SEARCH.MULTIPLE]({commit, getters}, payload) {
    const {searchString} = payload;

    const i18nEntries = await MHTTPCL.post(SETTINGS_URL, {
      section: 'language',
      search: searchString,
      output: 'json',
    });

    commit(types.LanguageSettingsData.SET.ALL, {
      ...getters.languageSettingsData,
      i18n: i18nEntries.data.i18n,
    });
  },
  async [types.I18NEntry.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { name, value, item, lang_code } = payload;
    const prev = item['textkey'];
    const tsec= item['section'];

    commit(types.LanguageSettingsData.SET.ALL, {
      ...getters.languageSettingsData,
      i18n: getters.languageSettingsData.i18n.map(i => {
        if (i['textkey'] == item['textkey']) {
          return {
            ...i,
            [lang_code]: value,
          };
        } else {
          return i;
        }
      })
    });

    const updatedI18NEntry = await MHTTPCL.post(SETTINGS_URL, {
      tsec: 'invoice',
      section: 'language',
      action: 'edit_i18n',
      tkey: name,
      term: value,
      tsec,
      lang_code,
      prev,
    })
  },
}
